var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginMs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7910_317179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.621582 1.20064C0.621582 0.734946 0.986088 0.357422 1.43573 0.357422H14.5638C15.0135 0.357422 15.378 0.734946 15.378 1.20064V14.7976C15.378 15.2633 15.0135 15.6408 14.5638 15.6408H1.43573C0.986088 15.6408 0.621582 15.2633 0.621582 14.7976V1.20064Z",
    fill: "#1B64B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.621826 2.6543H5.47247V6.98323H0.621826V2.6543Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.621582 6.98242H5.47223V11.3114H0.621582V6.98242Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47217 2.6543H10.5272V6.98323H5.47217V2.6543Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47217 6.98242H10.5272V11.3114H5.47217V6.98242Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47217 11.3115H10.5272V15.6405H5.47217V11.3115Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5273 2.6543H15.3779V6.98323H10.5273V2.6543Z",
    fill: "#50D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5273 6.98242H15.3779V11.3114H10.5273V6.98242Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5022 11.3115H15.3781V14.8005C15.3781 15.2644 15.002 15.6405 14.5381 15.6405H10.5022V11.3115Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47241 11.3115H0.6215V14.8005C0.6215 15.2644 0.997581 15.6405 1.4615 15.6405H5.47241V11.3115Z",
    fill: "#064A8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7910_317179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMs);
export default __webpack_public_path__ + "static/media/login-ms.86b39f2a247a5295373edb1f5b392942.svg";
export { ForwardRef as ReactComponent };